import { Box, Button, Grid, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useContext, useEffect } from 'react'
import { InfoContext } from '../services/Context/Info/context';
import User from '../services/db/user';

const columns = [
    { headerName: "Id", field: 'id' },
    {
        headerName: "Serviec Provider",
        field: "displayName",
        width: 200,
    },
    {
        headerName: "Subscrption type",
        field: "duration",
        width: 150
    },
    {
        headerName: "End Date",
        field: "subscribedDuration",
        width: 100,
        renderCell: ({ row: { subscribedDuration } }) => new Date(subscribedDuration.toDate()).toLocaleDateString('en-IN')
    },
    { headerName: "Amount", field: "amount" },
    {
        headerName: "Action", renderCell: ({ row: v }) => (
            <Button
                variant='contained'
                color='primary'
                // onClick={() => console.log(v)}
                href={v.invoice ? v.invoice : undefined}
                component='a'
                referrerPolicy='no-referrer'
                target='_blank'
            >
                View
            </Button>

        )
    }
]

const Invoices = () => {
    const { data: { invoiceData }, setData } = useContext(InfoContext);
    useEffect(() => {
        new User().allServiceProviders(10).then(r => {
            setData(p => ({ ...p, invoiceData: r.map((el, id) => ({ ...el, id: id + 1 })) }))
        })
    }, []);
    const getRowSpacing = React.useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    return (
        <Box>
            <Grid xs={12} container direction='column' paddingTop={2} paddingLeft={4}>
                <Grid xs={12} paddingY={1}>
                    <Typography variant='h6'>Invoices</Typography>
                </Grid>
                <Grid paddingTop={5}>
                    <DataGrid
                        className='datagrid'
                        rows={invoiceData}
                        columns={columns}
                        getRowClassName={() => 'row'}
                        showCellVerticalBorder={false}
                        getRowId={(row) => `${row.phoneNumber}_${row.role}`}
                        // ref={pdfRef}
                        hideFooterPagination={true}
                        getRowSpacing={getRowSpacing}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default Invoices